var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"loading-mask"}},[_c('div',{staticClass:"loading-wrapper"},[_c('span',{staticClass:"loading-dot loading-dot-spin"},[_c('i'),_c('i'),_c('i'),_c('i')])])])
}]

export { render, staticRenderFns }